import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width||149}
    height={props.width|| 149}
    viewBox="0 0 149 149"
    fill="none"
    style={props?.style||{}}
  >
    <path
      fill={props.isSelected?(props.color||"#67FFED"):"#F1F1F1"}
      d="m149 74.5-37.25 64.519h-74.5L0 74.5 37.25 9.981h74.5L149 74.5Z"
    />
    <path fill="#E7E7E7" d="M105.5 126 136 75H14l30.5 51h61Z" />
    <path fill="#EAEAEA" d="M44.5 22 14 75h122l-30.5-53h-61Z" />
  </svg>
)
export default SvgComponent
